import React from 'react';
import ReactDOM from 'react-dom';

import { ILoadingProps } from './index.d';
import './index.module.less';

const container = document.getElementById('loading');
const elementId = 'Loading';
export let useLoadingCount = 0;

export const Loading = (props: ILoadingProps) => {
  return (
    <div className="flex flex-center" styleName="bg">
      <div id={elementId} styleName="loading" className="flex flex-center">
        <div styleName="circle" />
        <p>{props.title || '加载中'}</p>
      </div>
    </div>
  );
};

export const showLoading = (title?: string) => {
  useLoadingCount += 1;
  if (document.getElementById(elementId) !== null) {
    return;
  }
  ReactDOM.render(<Loading title={title} />, container);
};

export const hideLoading = () => {
  useLoadingCount -= 1;
  if (useLoadingCount <= 0) {
    useLoadingCount = 0;
    ReactDOM.unmountComponentAtNode(container);
  }
};
